// Gemeinsamer Start jeder App: React einhängen und – nur in der gebauten
// Fassung – den Service Worker anmelden, der die App am Gerät ablegt.
// Seit E2 (O46): Wechselt der Service Worker auf eine neue Fassung, steht
// oben „Neue Fassung – tippen zum Neuladen“.

import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import type { AppName } from "@happy-energy/kern";
import { fehlerMelden, fehlerwacheStarten } from "./fehlerwache.ts";
import { NeueFassung, neueFassungMelden } from "./fassung.tsx";
import "./marke.css";

export function appStarten(app: AppName, inhalt: ReactNode): void {
  const wurzel = document.getElementById("app");
  if (!wurzel) throw new Error("Element #app fehlt in index.html");
  if (import.meta.env.PROD) fehlerwacheStarten(app);
  createRoot(wurzel, {
    onUncaughtError: (fehler) => {
      console.error(fehler);
      if (import.meta.env.PROD) fehlerMelden(app, fehler);
    },
  }).render(
    <StrictMode>
      {inhalt}
      <NeueFassung />
    </StrictMode>,
  );

  if (import.meta.env.PROD && "serviceWorker" in navigator) {
    // Hatte die Seite schon einen Service Worker, ist jeder Wechsel eine neue
    // Fassung. Beim allerersten Laden übernimmt er nur – das ist keine.
    const hatteFassung = navigator.serviceWorker.controller !== null;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (hatteFassung) neueFassungMelden();
    });
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").then(
        (anmeldung) => {
          // Die App bleibt am Handy oft tagelang offen: Beim Zurückholen nach
          // vorne einmal nachsehen, ob es eine neue Fassung gibt.
          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible" && navigator.onLine) void anmeldung.update().catch(() => undefined);
          });
        },
        (fehler: unknown) => {
          console.warn("Service Worker nicht angemeldet:", fehler);
        },
      );
      // Bitte um dauerhaften Speicher, damit der Browser nichts wegräumt,
      // was noch im Postausgang wartet (PLAN.md, Abschnitt 3).
      void navigator.storage?.persist?.();
    });
  }
}
